import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Instagram, ShoppingBag } from 'lucide-react';
import { BRAND } from '../mock';
import { useCart } from '../context/CartContext';

const NavLinks = ({ onClick, onHome }) => {
  const items = [
    { href: '#koleksiyon', label: 'Koleksiyon' },
    { href: '#hikayemiz', label: 'Hikâyemiz' },
    { href: '#sss', label: 'SSS' },
    { href: '#iletisim', label: 'İletişim' },
  ];
  return (
    <>
      {items.map((l) =>
        onHome ? (
          <a
            key={l.href}
            href={l.href}
            onClick={onClick}
            className="text-[13px] tracking-[0.14em] uppercase text-stone-700 hover:text-stone-950 transition-colors duration-300"
          >
            {l.label}
          </a>
        ) : (
          <Link
            key={l.href}
            to={`/${l.href}`}
            onClick={onClick}
            className="text-[13px] tracking-[0.14em] uppercase text-stone-700 hover:text-stone-950 transition-colors duration-300"
          >
            {l.label}
          </Link>
        )
      )}
    </>
  );
};

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { totalQty } = useCart();
  const location = useLocation();
  const onHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled || !onHome ? 'bg-[#f7f2ec]/90 backdrop-blur-md border-b border-stone-200' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/images/leila-logo.jpg"
            alt="Leila Tesettür"
            className="h-14 w-14 rounded-full object-cover shadow-sm ring-1 ring-stone-200"
          />
          <span className="hidden sm:inline text-[10px] tracking-[0.3em] uppercase text-stone-500">Tesettür</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLinks onHome={onHome} />
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a
            href={BRAND.instagramUrl}
            target="_blank"
            rel="noreferrer"
            className="p-2 text-stone-700 hover:text-stone-950 transition-colors"
            aria-label="Instagram"
          >
            <Instagram className="h-4 w-4" />
          </a>
          <Link
            to="/sepet"
            className="relative inline-flex items-center gap-2 px-4 py-2.5 border border-stone-900 text-stone-900 text-[11px] tracking-[0.18em] uppercase hover:bg-stone-900 hover:text-[#f7f2ec] transition-colors"
          >
            <ShoppingBag className="h-4 w-4" /> Sepet
            {totalQty > 0 && (
              <span className="absolute -top-2 -right-2 h-5 min-w-5 px-1 rounded-full bg-red-600 text-white text-[10px] font-semibold flex items-center justify-center">
                {totalQty}
              </span>
            )}
          </Link>
          <a
            href={BRAND.whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="px-5 py-2.5 bg-stone-900 text-[#f7f2ec] text-[12px] tracking-[0.18em] uppercase hover:bg-stone-800 transition-colors"
          >
            İletişim
          </a>
        </div>

        <div className="md:hidden flex items-center gap-3">
          <Link to="/sepet" className="relative p-2 text-stone-900" aria-label="Sepet">
            <ShoppingBag className="h-5 w-5" />
            {totalQty > 0 && (
              <span className="absolute -top-0.5 -right-0.5 h-4 min-w-4 px-1 rounded-full bg-red-600 text-white text-[10px] font-semibold flex items-center justify-center">
                {totalQty}
              </span>
            )}
          </Link>
          <button
            className="text-stone-900"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#f7f2ec] border-t border-stone-200 px-6 py-6 flex flex-col gap-5">
          <NavLinks onClick={() => setOpen(false)} onHome={onHome} />
          <a
            href={BRAND.whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-2 px-5 py-3 bg-stone-900 text-[#f7f2ec] text-[12px] tracking-[0.18em] uppercase text-center"
          >
            WhatsApp ile İletişim
          </a>
        </div>
      )}
    </header>
  );
}
